var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10ZM10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8Z",
    fill: "#0864A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8716 4.16739C13.4117 3.86159 12.791 3.98651 12.4852 4.44641C12.1794 4.90631 12.3043 5.52703 12.7642 5.83282C13.3199 6.20233 13.7978 6.68018 14.1672 7.23591C14.473 7.69582 15.0937 7.82076 15.5537 7.51497C16.0136 7.20919 16.1385 6.58848 15.8327 6.12857C15.3161 5.35159 14.6486 4.68401 13.8716 4.16739Z",
    fill: "#0864A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83272 12.7641C5.52693 12.3042 4.90621 12.1793 4.44631 12.4851C3.9864 12.7909 3.86147 13.4116 4.16725 13.8715C4.68392 14.6486 5.35158 15.3162 6.12867 15.8329C6.58859 16.1386 7.2093 16.0137 7.51507 15.5538C7.82084 15.0938 7.69589 14.4731 7.23597 14.1674C6.68017 13.7978 6.20226 13.3199 5.83272 12.7641Z",
    fill: "#0864A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2Z",
    fill: "#0864A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.50e71ab0a305e92b41944eb020d9ab11.svg";
export { ForwardRef as ReactComponent };